import { render, staticRenderFns } from "./FootprintBungeSilos.vue?vue&type=template&id=d69a28a4&lang=pug"
import script from "./FootprintBungeSilos.vue?vue&type=script&lang=js"
export * from "./FootprintBungeSilos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports